import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { PdfDocumentViewportComponent } from './components/pdf-document-viewport/pdf-document-viewport.component';
import { PdfDocumentViewportsContainerComponent } from './components/pdf-document-viewports-container/pdf-document-viewports-container.component';
import { PdfDocumentViewportsContainerService } from './components/pdf-document-viewports-container/pdf-document-viewports-container.service';
import { PdfPageComponent } from './components/pdf-page/pdf-page.component';
import { PdfThumbnailViewportComponent } from './components/pdf-thumbnail-viewport/pdf-thumbnail-viewport.component';
import { PdfThumbnailViewportsContainerComponent } from './components/pdf-thumbnail-viewports-container/pdf-thumbnail-viewports-container.component';
import { PdfThumbnailComponent } from './components/pdf-thumbnail/pdf-thumbnail.component';
import { PdfTitleComponent } from './components/pdf-title/pdf-title.component';
import { PdfMenuBtnComponent } from './components/pdf-toolbar/pdf-menu-btn/pdf-menu-btn.component';
import { PdfFirstPageComponent } from './components/pdf-toolbar/pdf-pagination/pdf-first-page/pdf-first-page.component';
import { PdfLastPageComponent } from './components/pdf-toolbar/pdf-pagination/pdf-last-page/pdf-last-page.component';
import { PdfNextPageComponent } from './components/pdf-toolbar/pdf-pagination/pdf-next-page/pdf-next-page.component';
import { PdfPageNumberComponent } from './components/pdf-toolbar/pdf-pagination/pdf-page-number/pdf-page-number.component';
import { PdfPaginationComponent } from './components/pdf-toolbar/pdf-pagination/pdf-pagination.component';
import { PdfPreviousPageComponent } from './components/pdf-toolbar/pdf-pagination/pdf-previous-page/pdf-previous-page.component';
import { PdfToolbarComponent } from './components/pdf-toolbar/pdf-toolbar.component';
import { PdfZoomDropdownComponent } from './components/pdf-toolbar/pdf-zoom/pdf-zoom-dropdown/pdf-zoom-dropdown.component';
import { PdfZoomHorizontalFitComponent } from './components/pdf-toolbar/pdf-zoom/pdf-zoom-horizontal-fit/pdf-zoom-horizontal-fit.component';
import { PdfZoomInComponent } from './components/pdf-toolbar/pdf-zoom/pdf-zoom-in/pdf-zoom-in.component';
import { PdfZoomOutComponent } from './components/pdf-toolbar/pdf-zoom/pdf-zoom-out/pdf-zoom-out.component';
import { PdfZoomComponent } from './components/pdf-toolbar/pdf-zoom/pdf-zoom.component';
import { PdfZoomService } from './components/pdf-toolbar/pdf-zoom/pdf-zoom.service';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { ObjectValuesPipe } from './pipes/object-values.pipe';


@NgModule({
  declarations: [
    PdfDocumentViewportsContainerComponent,
    PdfDocumentViewportComponent,
    PdfPageComponent,
    PdfThumbnailComponent,
    PdfThumbnailViewportComponent,
    PdfThumbnailViewportsContainerComponent,
    PdfViewerComponent,
    PdfTitleComponent,
    PdfMenuBtnComponent,

    PdfZoomComponent,
    PdfZoomDropdownComponent,
    PdfZoomHorizontalFitComponent,
    PdfZoomInComponent,
    PdfZoomOutComponent,
    PdfToolbarComponent,

    PdfPaginationComponent,
    PdfFirstPageComponent,
    PdfLastPageComponent,
    PdfNextPageComponent,
    PdfPageNumberComponent,
    PdfPreviousPageComponent,

    ObjectValuesPipe
  ],
  exports: [
    PdfViewerComponent,
    PdfDocumentViewportsContainerComponent,
    PdfThumbnailViewportsContainerComponent
  ],
  imports: [
    CommonModule,

    MatSlideToggleModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatCardModule,
    TranslateModule,

    ScrollingModule,

  ],
  providers: [
    PdfDocumentViewportsContainerService,
    PdfZoomService
  ],
})
export class PdfModule { }
